export const GET_CATEGORY_LIST_START_LOADING = 'GUIDE/GET_CATEGORY_LIST_START_LOADING';
export const GET_CATEGORY_LIST_END_LOADING = 'GUIDE/GET_CATEGORY_LIST_END_LOADING';
export const GET_CATEGORY_LIST_REQUEST = 'GUIDE/GET_CATEGORY_LIST_REQUEST';
export const GET_CATEGORY_LIST_SUCCESS = 'GUIDE/GET_CATEGORY_LIST_SUCCESS';
export const GET_CONTENTS_LIST_REQUEST = 'GUIDE/GET_CONTENTS_LIST_REQUEST';
export const GET_CONTENTS_LIST_SUCCESS = 'GUIDE/GET_CONTENTS_LIST_SUCCESS';
export const SET_SELECTED_CATEGORY_ID = 'GUIDE/SET_SELECTED_CATEGORY_ID';
export const DELETE_SELECTED_CATEGORY_ID = 'GUIDE/DELETE_SELECTED_CATEGORY_ID';
export const DELETE_PAGE_INFO = 'GUIDE/DELETE_PAGE_INFO';
